module.exports = __webpack_public_path__ + "static/media/heatIndex.396271c1.svg";